/* Sampson cart gift-ladder: auto-add/remove $0 gift variants by cart total.
   $20 -> Low-Tox Guide (PDF), $40 -> Bamboo Straw, $55 -> Lip Balm, $65 -> Tote.
   $75 free shipping is NOT a variant here — it's a Shopify shipping rule (display-only in the bar).
   Loads globally (cart-drawer section) so it survives drawer re-renders. */
/* Sampson shared cart-write lock (idempotent; defined by whichever cart script loads first).
   Serializes every cart-mutating write across product-form, gift-ladder, cart-items and
   smart-recs so two /cart/add.js|/cart/change.js writes never overlap -> no Shopify 422/429
   race -> no silently-swallowed add. Deadman-releases the queue after 12s so a hung fetch
   can't freeze all future cart writes. */
window.SampsonCartLock = window.SampsonCartLock || (function () {
  var tail = Promise.resolve();
  return { run: function (fn) {
    var result = tail.then(fn, fn);
    tail = new Promise(function (release) {
      var done = false, fin = function () { if (!done) { done = true; release(); } };
      result.then(fin, fin); setTimeout(fin, 12000);
    });
    return result;
  } };
})();

(function(){
  if (window.__cglInit) return; window.__cglInit = true;
  /* locale-aware guide variant: The Low-Tox Home Guide (Free) — EN vs FR digital $0 */
  var CGL_FR = ((((window.Shopify && Shopify.locale) || document.documentElement.lang || '') + '').toLowerCase().indexOf('fr') === 0)
               || (location.pathname.toLowerCase().indexOf('/fr') === 0);
  var LADDER = [
    {amt:2000, v: CGL_FR ? 47477625979011 : 47471049736323},  /* $20 -> Low-Tox Home Guide (FR/EN) */
    {amt:4000, v:43484410019971},   /* $40 -> reusable straw */
    {amt:5500, v:47310100365443},   /* $55 -> lip balm */
    {amt:6500, v:47291986968707}    /* $65 -> tote */
  ];
  var GIFTV = LADDER.map(function(x){ return x.v; });
  var running = false, again = false, dbt = null;
  var DEAD = {};   /* gift variants that failed to add this session (archived/unpublished) — never retried */

  function drawerEl(){ return document.querySelector('cart-drawer'); }
  function sections(){
    var s = ['cart-icon-bubble'], cd = drawerEl();
    if (cd && cd.closest('.shopify-section')) s.push(cd.closest('.shopify-section').id.replace('shopify-section-',''));
    return s;
  }
  function render(d){ var cd = drawerEl(); if (cd && typeof cd.renderContents === 'function'){ try{ cd.renderContents(d); }catch(e){} } }
  function post(url, body){
    body.sections = sections(); body.sections_url = window.location.pathname;
    return window.SampsonCartLock.run(function(){
      return fetch(url, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/javascript'}, body: JSON.stringify(body)}).then(function(r){ return r.json(); });
    });
  }
  function evaluate(){
    if (running){ again = true; return; }
    running = true;
    fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(cart){
      var total = cart.total_price, inCart = {};
      (cart.items||[]).forEach(function(it){ if (GIFTV.indexOf(it.variant_id) >= 0) inCart[it.variant_id] = it.key; });
      var addV = null, removeKey = null;
      for (var i=0;i<LADDER.length;i++){
        var L = LADDER[i], should = total >= L.amt, has = inCart[L.v];
        if (should && !has && !DEAD[L.v]){ addV = L.v; break; }
        if (!should && has){ removeKey = has; break; }
      }
      if (addV){ return post('/cart/add.js', {items:[{id:addV, quantity:1}]}).then(function(d){
        // Sampson: an unaddable gift (archived/unpublished -> 422 json) must be blacklisted for
        // the session, or the observer loop retries it forever ("gift ladder restarts", 429 storm).
        if (d && d.status && d.status >= 400){ DEAD[addV] = 1; finish(false); return; }
        render(d); finish(true);
      }); }
      if (removeKey){ return post('/cart/change.js', {id:removeKey, quantity:0}).then(function(d){ render(d); finish(true); }); }
      finish(false);
    }).catch(function(){ finish(false); });
  }
  function finish(changed){ running = false; if (again || changed){ again = false; setTimeout(evaluate, 70); } }
  function schedule(){ clearTimeout(dbt); dbt = setTimeout(evaluate, 130); }
  function init(){
    var cd = drawerEl();
    if (!cd) return; /* slide-cart only; /cart page keeps its own bar */
    new MutationObserver(function(){ if (!running) schedule(); }).observe(cd, {childList:true, subtree:true});
    document.addEventListener('cart:refresh', evaluate);
    evaluate();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

